import { getAttendanceSourceIconName, Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { getAttendanceSourceTranslationKey } from "@msuite/utils/attendances";
import type { Enums, Nullable } from "@msuite/utils/types";

/** Props Interface */
interface AttendanceCardSourceProps {
	source: Nullable<Enums<"attendanceSource">>;
}

/**
 * Which client booked one end of an attendance, as the caption under the time it booked.
 *
 * A row written before the columns existed carries no source, and so does the open end of a live
 * attendance — neither is unknown, both are simply not yet a fact, so nothing is drawn rather than
 * a placeholder claiming ignorance on every historical row.
 */
export function AttendanceCardSource({ source }: AttendanceCardSourceProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!source) return null;

	/** Render */
	// Indented past the arrow above it, so the caption hangs under the time rather than the icon.
	return (
		<div className="h-stack gap-1 pl-5">
			<Icon
				name={getAttendanceSourceIconName(source)}
				size={10}
			/>
			<p className="label">{t(getAttendanceSourceTranslationKey(source))}</p>
		</div>
	);
}
